import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Link } from 'react-router-dom';
import { Grid, Header, Icon, Image, Segment } from 'semantic-ui-react';
import { ApplicationState } from '../..';

const connector = connect(
    (state: ApplicationState) => ({ 
        logo: state.core.auth.user!.profile.picture!,
        anagrafica: state.core.anagrafiche.anagrafica!
    })
)
type PropsFromRedux = ConnectedProps<typeof connector>

type HomeProps = PropsFromRedux

class Home extends React.Component<HomeProps> {

    render() {
        const { logo, anagrafica } = this.props;
        return (
            <Grid centered stackable>
                <Grid.Row />
                <Grid.Row>
                    <Image src={logo} alt={anagrafica.ragioneSociale} size='small' />
                </Grid.Row>
                <Grid.Row />
                <Grid.Row>
                    <Header as='h2'>
                        <Header.Content>
                            COME POSSIAMO AIUTARTI?
                            <Header.Subheader>{anagrafica.ragioneSociale}</Header.Subheader>
                        </Header.Content>
                    </Header>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width='5' as={Link} to="/portal/ordini/materiale">
                        <Segment textAlign='center'>
                            <h4>HO BISOGNO DI CONSUMABILI</h4>
                            <Icon name="zip" size="huge" />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column width='5' as={Link} to="/portal/ordini/elenco">
                        <Segment textAlign='center'>
                            <h4>ELENCO ORDINI</h4>
                            <Icon name="list" size="huge" />
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default connector(Home);